import useOverlayBadge from "@insite/client-framework/Common/Hooks/useOverlayBadge";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setSelectedImageIndex from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/SetSelectedImageIndex";
import { getSelectedImage } from "@insite/client-framework/Store/Pages/ProductDetails/ProductDetailsSelectors";
import { ImageModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
// import ProductImageCarousel, {
//     ProductImageCarouselStyles,
// } from "@insite/content-library/Components/ProductImageCarousel";
import Button from "@insite/content-library/Widgets/Basic/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem/GridItem";
import Hidden from "@insite/mobius/Hidden/Hidden";
import Icon from "@insite/mobius/Icon/Icon";
import X from "@insite/mobius/Icons/X";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import { StyledIcon } from "@insite/mobius/Link/Link";
import { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ProductCustomPrimaryImage from "@tSurya/Components/ProductCustomPrimaryImage";
import CustomExpandIcon from "@tSurya/Icons/CustomExpandIcon";
import NextArrow from "@tSurya/Icons/NextArrow";
import PreviousArrow from "@tSurya/Icons/PreviousArrow";
import ChevronLeft from "@tSurya/MobiusOverrides/Icons/ChevronLeft";
import ChevronRight from "@tSurya/MobiusOverrides/Icons/ChevronRight";
import ProductImageCarousel, { ProductImageCarouselStyles } from "@tSurya/Overrides/Components/ProductImageCarousel";
import ProductPrimaryImage, { ProductPrimaryImageStyles } from "@tSurya/Overrides/Components/ProductPrimaryImage";
import { COLORS } from "@tSurya/theme/design";
import { useEmblaCarousel } from "embla-carousel/react";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

type Props = WidgetProps &
    HasProductContext &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps>;

const mapStateToProps = (state: ApplicationState, ownProps: HasProductContext) => ({
    selectedImage: getSelectedImage(state, ownProps.productContext.product),
    selectedImageIndex: state.pages.productDetails.selectedImageIndex,
});

const mapDispatchToProps = {
    setSelectedImageIndex,
};

export interface ProductDetailsPrimaryImageStyles {
    /**
     * @deprecated Use primaryImage styles instead.
     */
    centeringWrapper?: InjectableCss;
    hiddenWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    image?: LazyImageProps;

    primaryImage?: ProductPrimaryImageStyles;
    fullPrimaryImageModal?: ModalPresentationProps;
    fullPrimaryImageModalLandscape?: ModalPresentationProps;
    fullPrimaryImage?: ProductPrimaryImageStyles;
    imageCarousel?: ProductImageCarouselStyles;
    badgeAreaWrapper?: InjectableCss;
    badgeTextWrapper?: InjectableCss;
    badgeImageWrapper?: InjectableCss;
    badgeText?: TypographyPresentationProps;
    badgeImageProps?: JSX.IntrinsicElements["img"];
    container: InjectableCss;
    arrowImage: InjectableCss;
    prevArrowGridItem?: GridItemProps;
    nextArrow?: InjectableCss;
    prevArrow?: InjectableCss;
    modalContainer?: InjectableCss;
    primaryImageConatiner?: InjectableCss;
    iframePrimaryImageConatiner?: InjectableCss;
    crossIcon?: InjectableCss;
    crossIconvideo?: InjectableCss;
    productCrousal?: InjectableCss;
    expandIcon?: InjectableCss;
    positionAbsolute?: InjectableCss;
    videoPlayerContainer?: InjectableCss;
    youTubeVideoStyles?: InjectableCss;
    iframeModalContainer?: InjectableCss;
    iframeModalContainerLandscape?: InjectableCss;
    modalVideoStyles?: ModalPresentationProps;
}

export const primaryImageStyles: ProductDetailsPrimaryImageStyles = {
    youTubeVideoStyles: {
        css: css`
            max-height: 610px;
            height: 100vh;
            width: 100%;
            display: flex;
            align-items: center;
        `,
    },
    modalVideoStyles: {
        sizeVariant: "large",
        cssOverrides: {
            modalContent: css`
                > div {
                    padding-bottom: 56.2%;
                    position: relative;
                }
            `,
            modalBody: css`
                max-width: 860px !important;
            `,
            modalContainer: css`
                iframe {
                    position: absolute;
                }
            `,
        },
    },
    fullPrimaryImageModal: {
        sizeVariant: "large",
        cssOverrides: {
            modalContainer: css`
                width: 100% !important;
                height: 100% !important;
                padding: 0px;
            `,
            modalBody: css`
                width: 100%;
                height: 100vh !important;
                max-height: 100% !important;
                max-width: 100% !important;
                margin: 0px !important;
                position: relative;
                > div[data-test-selector^="modal_ModalContent"] {
                    img {
                        max-height: 100%;
                    }
                }
            `,
            modalTitle: css`
                border-bottom: none;
                padding: 0px;
                display: none;
            `,
            modalContent: css`
                text-align: center;
                position: relative;
                display: flex;
                flex-direction: row-reverse;
                flex-basis: auto;
                max-width: auto;
                width: auto;
                padding: 0px;
                height: 100%;
                justify-content: center;
                > div {
                    iframe {
                        > video {
                            position: absolute !important;
                            left: 0px !important;
                            width: -webkit-fill-available !important;
                        }
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(theme, [
                                null,
                                null,
                                css`
                                    position: absolute;
                                    width: 49.5vh;
                                    height: 28vh;
                                `,
                                css`
                                    max-height: 27.5vh;
                                    height: 28.5vh;
                                    position: absolute;
                                    width: 48.5vh;
                                `,
                                null,
                            ])};
                    }
                    > div:nth-child(2) {
                        width: 60%;
                        height: 100%;
                    }
                }
            `,
        },
    },
    fullPrimaryImageModalLandscape: {
        sizeVariant: "large",
        cssOverrides: {
            modalContainer: css`
                width: 100% !important;
                height: 100% !important;
                padding: 0px;
            `,
            modalBody: css`
                width: 100%;
                height: 100vh !important;
                max-height: 100% !important;
                max-width: 100% !important;
                margin: 0px !important;
                position: relative;
                > div[data-test-selector^="modal_ModalContent"] {
                    img {
                        max-height: 100%;
                    }
                }
            `,
            modalTitle: css`
                border-bottom: none;
                padding: 0px;
                display: none;
            `,
            modalContent: css`
                text-align: center;
                position: relative;
                display: flex;
                flex-direction: row-reverse;
                flex-basis: auto;
                max-width: auto;
                width: auto;
                padding: 0px;
                height: 100%;
                justify-content: center;
                > div {
                    iframe {
                        max-height: 57vh;
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(theme, [
                                null,
                                null,
                                css`
                                    aspect-ratio: 16/9;
                                `,
                                css`
                                    aspect-ratio: 16/9;
                                `,
                                null,
                            ])};
                    }
                    > div:nth-child(2) {
                        width: 60%;
                        height: 100%;
                    }
                }
            `,
        },
    },
    fullPrimaryImage: {
        image: {
            css: css`
                img {
                    width: auto;
                    max-height: 70vh;
                }
            `,
        },
        img: {
            css: css`
                width: 100vh !important;
                max-height: 100vh !important;
            `,
        },
    },
    container: {
        css: css`
            position: relative;
            img {
                aspect-ratio: 63 / 63;
                width: 100%;
                object-fit: contain;
                padding-top: 20px;
                padding-bottom: 20px;
                /* mix-blend-mode: multiply; */
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            width: 100%;
                            height: none;
                            object-fit: contain;
                            aspect-ratio: 1/ 1;
                            max-width: 100%;
                        `,
                        css`
                            width: 100%;
                            object-fit: contain;
                            aspect-ratio: 1/ 1;
                            max-width: 100%;
                        `,
                        css`
                            width: 100%;
                            object-fit: contain;
                            aspect-ratio: 1/ 1;
                            max-width: 100%;
                        `,
                        null,
                        null,
                    ])}
            }
        `,
    },
    primaryImage: {
        centeringWrapper: {
            css: css`
                background-color: #f8f8f8;
            `,
        },
        img: {
            css: css`
                padding: 20px 0px;
            `,
        },
    },
    arrowImage: {
        css: css`
            position: absolute;
            top: 10px;
            right: 10px;
            cursor: pointer;
        `,
    },
    modalContainer: {
        css: css`
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            flex-direction: row-reverse;
            width: 100%;
        `,
    },
    crossIcon: {
        css: css`
            cursor: pointer;
            padding: 5px;
            margin: 10px;
            margin-right: 20px;
            border: 1px solid ${getColor("common.border")};
            width: 38px;
            height: 37px;
        `,
    },
    crossIconvideo: {
        css: css`
            cursor: pointer;
            padding: 5px;
            margin: 10px;
            margin-right: 20px;
            border: 1px solid ${getColor("common.border")};
            width: 50px;
            margin-left: auto;
            display: flex;
            align-items: center;
            justify-content: center;
        `,
    },
    primaryImageConatiner: {
        css: css`
            display: flex;
            justify-content: center;
            align-items: center;
            iframe {
                height: 97vh;
                width: 100vh;
            }
        `,
    },
    iframePrimaryImageConatiner: {
        css: css`
            display: flex;
            justify-content: center;
            align-items: center;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        position: relative;
                        width: 100%;
                        height: 0;
                        margin-left: 20px;
                    `,
                    css`
                        position: relative;
                        width: 100%;
                        height: 0;
                        margin-left: 20px;
                    `,
                    css`
                        position: relative;
                        width: 100%;
                        height: 0;
                        margin-left: 20px;
                    `,
                    null,
                    null,
                ])}
            iframe {
                height: 57vh;
                width: 101vh;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            width: 100%;
                            height: 100%;
                        `,
                        css`
                            width: 100%;
                            height: 100%;
                        `,
                        css`
                            width: 100%;
                            height: 100%;
                        `,
                        null,
                        null,
                    ])}
            }
        `,
    },
    productCrousal: {
        css: css`
            margin-top: 15px;
            width: 8%;
            padding-left: 20px;
            .slideContainer {
                height: 80vh !important;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    css`
                        width: 12%;
                        padding-left: 20px;
                        > div[class^="GridWrapper"] > div[class^="GridOffset"] {
                            flex-wrap: wrap !important;
                            margin-top: 16px !important;
                        }
                    `,
                    null,
                    null,
                ])};
            > div[class^="GridWrapper"] > div[class^="GridOffset"] {
                margin-top: 16px !important;
            }
        `,
    },
    prevArrow: {
        css: css`
            cursor: pointer;
            margin-right: 50px;
        `,
    },
    nextArrow: {
        css: css`
            cursor: pointer;
            margin-left: 50px;
        `,
    },
    expandIcon: {
        css: css`
            svg {
                fill: black;
                z-index: 11;
            }
        `,
    },
    imageCarousel: {
        carouselWrapper: {
            css: css``,
        },
        carouselSlidesContainer: {
            css: css`
                flex-direction: row;
            `,
        },

        prevArrowGridItem: {
            css: css`
                transform: rotate(270deg);
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        null,
                        css`
                            transform: rotate(270deg);
                            flex-basis: auto;
                            max-width: none;
                            > button {
                                border: 0px;
                                &:focus {
                                    outline-width: 0px;
                                }
                            }
                        `,
                        null,
                        null,
                    ])};
                > button {
                    border: 0px;
                    &:focus {
                        outline-width: 0px;
                    }
                }
            `,
        },
        nextArrowGridItem: {
            css: css`
                transform: rotate(90deg);
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        null,
                        css`
                            transform: rotate(90deg);
                            flex-basis: auto;
                            max-width: none;
                            > button {
                                border: 0px;
                                &:focus {
                                    outline-width: 0px;
                                }
                            }
                        `,
                        null,
                        null,
                    ])};
                > button {
                    border: 0px;
                    &:focus {
                        outline-width: 0px;
                    }
                }
            `,
        },
        carouselSlideInner: {
            css: css`
                background-color: ${getColor("common.backgroundContrast")};
            `,
        },
        carouselSlide: {
            css: css`
                margin: 0px;

                margin-bottom: 20px !important;
                &:last-child.is-selected {
                    margin-bottom: 0px !important;
                }
                &.is-selected {
                    > div {
                        background: white;
                    }
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        null,
                        null,
                        css`
                            margin: 0px !important;
                        `,
                        null,
                        null,
                    ])}
            `,
        },
    },
    positionAbsolute: {
        css: css`
            position: absolute;
            background: transparent;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            z-index: 9;
            cursor: pointer;
        `,
    },
    videoPlayerContainer: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
        `,
    },
    badgeAreaWrapper: {
        css: css`
            position: relative;
        `,
    },
    badgeTextWrapper: {
        css: css`
            position: absolute;
            width: 50%;
            white-space: nowrap;
            overflow: hidden;
        `,
    },
    badgeImageWrapper: {
        css: css`
            position: absolute;
            width: 25%;
            height: 25%;
        `,
    },
    badgeText: {
        weight: "bold",
        css: css`
            width: 100%;
            margin: auto;
            ${wrapInContainerStyles}
        `,
    },
    iframeModalContainer: {
        css: css``,
    },
    iframeModalContainerLandscape: {
        css: css``,
    },
};

const styles = primaryImageStyles;

const ProductDetailsPrimaryImage = ({
    productContext,
    selectedImage,
    selectedImageIndex,
    setSelectedImageIndex,
}: Props) => {
    const [fullPrimaryImageModalIsOpen, setFullImageModalIsOpen] = React.useState(false);
    const [videPlayerModalIsOpen, setVidePlayerModalIsOpen] = React.useState(false);
    const [isTabView, setIsTabView] = useState(false);
    const [isPortraitView, setIsPortraitview] = useState(true);
    const { product } = productContext;

    useEffect(() => {
        const handleOrientationChange = (e: { matches: any }) => {
            const portrait = e.matches;
            if (portrait) {
                setIsPortraitview(true);
            } else {
                setIsPortraitview(false);
            }
        };

        const mediaQuery = window.matchMedia("(orientation: portrait)");
        mediaQuery.addEventListener("change", handleOrientationChange);

        return () => {
            mediaQuery.removeEventListener("change", handleOrientationChange);
        };
    }, []);

    // const videoRegex = /^[0-9]{1,2}\.(?:mp4|mpg|avi)$/;

    // const viemoRegex =
    /(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_\-]+)?/i;
    const youtubeRegex = /^[a-zA-Z0-9_-]{11}$/;

    React.useEffect(() => {
        window.addEventListener("resize", onWindowResize);
        onWindowResize();

        return () => {
            window.removeEventListener("resize", onWindowResize);
        };
    }, []);
    const onWindowResize = () => {
        if (window.innerWidth >= 991) {
            setIsTabView(false);
        } else {
            setIsTabView(true);
        }
    };
    const imageClickHandler = () => {
        setFullImageModalIsOpen(true);
    };
    const fullPrimaryImageModalCloseHandler = () => {
        setFullImageModalIsOpen(false);
    };

    const selectImageHandler = (index: number) => {
        setSelectedImageIndex({ index });
    };

    const previousButtonHandler = (product: ProductModel) => {
        const length: any = product.images?.length;
        if (selectedImageIndex < 1) {
            selectedImageIndex = length - 0;
        }
        setSelectedImageIndex({ index: selectedImageIndex - 1 });
    };

    const nextButtonHandler = (product: ProductModel) => {
        const length: any = product.images?.length;
        if (selectedImageIndex > length - 1) {
            selectedImageIndex = 0;
        }
        setSelectedImageIndex({ index: selectedImageIndex + 1 });
    };
    if (!product) {
        return null;
    }
    const handleVideoClose = () => {
        setVidePlayerModalIsOpen(false);
    };

    const image =
        selectedImage ??
        ({
            id: product.id,
            imageAltText: product.imageAltText,
            imageType: "Static",
            largeImagePath: product.largeImagePath,
            mediumImagePath: product.mediumImagePath,
            smallImagePath: product.smallImagePath,
        } as ImageModel);

    const [emblaRef, embla] = useEmblaCarousel();

    const {
        showOverlayBadge,
        overlayBadge,
        overlayBadgeWrapperStyles,
        badgeAreaWrapperRef,
        overlayBadgeWrapperClickHandler,
    } = useOverlayBadge({
        productContext,
        showTextBadge: true,
        showImageBadge: true,
        styles,
    });

    const path = image.mediumImagePath || image.largeImagePath;
    if (!path) {
        return null;
    }

    return (
        <>
            <StyledWrapper {...styles.container}>
                {youtubeRegex.test(path) && !isTabView ? (
                    <StyledWrapper
                        css={css`
                            background-color: ${getColor("common.backgroundContrast")};
                        `}
                    >
                        <StyledWrapper
                            {...styles.positionAbsolute}
                            onClick={() => setVidePlayerModalIsOpen(true)}
                        ></StyledWrapper>
                        <StyledWrapper {...styles.youTubeVideoStyles}>
                            <iframe
                                src={`https://www.youtube.com/embed/${path}`}
                                width="100%"
                                height="340px"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            ></iframe>
                        </StyledWrapper>
                        <Modal
                            {...styles.modalVideoStyles}
                            isOpen={videPlayerModalIsOpen}
                            handleClose={handleVideoClose}
                        >
                            <StyledWrapper {...styles.modalContainer}>
                                <StyledWrapper {...styles.videoPlayerContainer}>
                                    <StyledWrapper {...styles.iframeModalContainer}>
                                        <iframe
                                            src={`https://www.youtube.com/embed/${path}?autoplay=1`}
                                            width="100%"
                                            height="100%"
                                            allowFullScreen
                                            frameBorder="0"
                                            allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        ></iframe>
                                    </StyledWrapper>
                                </StyledWrapper>
                            </StyledWrapper>
                        </Modal>
                    </StyledWrapper>
                ) : (
                    <ProductCustomPrimaryImage
                        product={product}
                        image={image}
                        extendedStyles={styles.primaryImage}
                        zoomType="outer"
                        zoomLevel={1.7}
                    />
                )}

                <Modal
                    {...(isPortraitView ? styles.fullPrimaryImageModal : styles.fullPrimaryImageModalLandscape)}
                    isOpen={fullPrimaryImageModalIsOpen}
                    // handleClose={fullPrimaryImageModalCloseHandler}
                >
                    <StyledWrapper {...styles.modalContainer}>
                        <StyledWrapper {...styles.crossIcon}>
                            <Icon src={X} onClick={fullPrimaryImageModalCloseHandler}></Icon>
                        </StyledWrapper>
                        <StyledWrapper
                            {...(youtubeRegex.test(path)
                                ? styles.iframePrimaryImageConatiner
                                : styles.primaryImageConatiner)}
                            ref={emblaRef}
                        >
                            <StyledWrapper {...styles.prevArrow}>
                                <Icon
                                    src={PreviousArrow}
                                    onClick={() => {
                                        previousButtonHandler(product);
                                    }}
                                ></Icon>
                            </StyledWrapper>
                            {youtubeRegex.test(path) ? (
                                <iframe
                                    src={`https://www.youtube.com/embed/${path}`}
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                ></iframe>
                            ) : (
                                <ProductPrimaryImage
                                    product={product}
                                    image={image}
                                    extendedStyles={styles.primaryImage}
                                    useLargeImage={true}
                                />
                            )}

                            <StyledWrapper {...styles.nextArrow}>
                                <Icon
                                    src={NextArrow}
                                    onClick={() => {
                                        nextButtonHandler(product);
                                    }}
                                ></Icon>
                            </StyledWrapper>
                        </StyledWrapper>
                        <StyledWrapper {...styles.productCrousal}>
                            {product.images && product.images.length > 1 && (
                                <ProductImageCarousel
                                    selectedIndex={selectedImageIndex}
                                    onSelectImage={selectImageHandler}
                                    extendedStyles={styles.imageCarousel}
                                    isModalOpen={fullPrimaryImageModalIsOpen}
                                />
                            )}
                        </StyledWrapper>
                    </StyledWrapper>
                </Modal>
                <Hidden below="md">
                    <StyledWrapper {...styles.arrowImage} onClick={imageClickHandler}>
                        <Icon src={CustomExpandIcon} {...styles.expandIcon}></Icon>
                    </StyledWrapper>
                </Hidden>
            </StyledWrapper>
        </>
    );
};
const widgetModule: WidgetModule = {
    component: withProductContext(connect(mapStateToProps, mapDispatchToProps)(ProductDetailsPrimaryImage)),
    definition: {
        displayName: "Primary Image",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
